/* eslint-disable @typescript-eslint/no-explicit-any */

export const isFirstOccurred = (object: any, index: number, array: any[], key?: string) => {
  const _array = key ? array.map((value) => value[key]) : array
  return _array.indexOf(key ? object[key] : object) === index
}

export const getUniqueArray = (array: any[], key?: string) => {
  return array.filter((value, index, array) => isFirstOccurred(value, index, array, key))
}
